/**
 * Input mask helpers for Brazilian document formats.
 * Used in profile settings and agent edit forms.
 */

/**
 * Applies CPF mask: 000.000.000-00
 * @param {string} value - Raw or partially masked input
 * @returns {string} Masked CPF string
 */
export const maskCpf = value => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 11);
  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
};

/**
 * Applies CEP mask: 00000-000
 * @param {string} value - Raw or partially masked input
 * @returns {string} Masked CEP string
 */
export const maskCep = value => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 8);
  return digits.replace(/(\d{5})(\d)/, '$1-$2');
};

/**
 * Applies Brazilian phone mask: (00) 0000-0000 or (00) 00000-0000
 * @param {string} value - Raw or partially masked input
 * @returns {string} Masked phone string
 */
export const maskPhone = value => {
  const digits = (value || '').replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 10) {
    return digits
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{4})(\d)/, '$1-$2');
  }
  return digits
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2');
};
